import {LANGUAGE_ABBREVATION} from "../../locales/locales";

/**
 * Determines the date format string based on the resolved language.
 *
 * @param {string | undefined} resolvedLanguage - The resolved language code as a string or undefined.
 *                                                Should correspond to LANGUAGE_ABBREVATION values.
 *                                                Supported values include:
 *                                                - "de" for German ("dd.MM.yyyy")
 *                                                - "en" for English ("MM/dd/yyyy")
 * @returns {string} The date format string. Returns:
 *                   - "dd.MM.yyyy" for German (if resolvedLanguage is "de").
 *                   - "MM/dd/yyyy" for English (if resolvedLanguage is "en").
 *                   - Default value "MM/dd/yyyy" if resolvedLanguage is undefined
 *                     or does not match a supported value.
 */
export const setDateFormat = (resolvedLanguage: string | undefined): string => {
    if (resolvedLanguage) {
        const resolvedLanguageEnum = resolvedLanguage as LANGUAGE_ABBREVATION
        switch (resolvedLanguageEnum) {
            case LANGUAGE_ABBREVATION.de:
                return "dd.MM.yyyy"
            case LANGUAGE_ABBREVATION.en:
                return "MM/dd/yyyy"
            default:
                resolvedLanguageEnum satisfies never

        }
    }
    return "MM/dd/yyyy"
}